import script from "./AssetSuccessPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./AssetSuccessPage.vue?vue&type=script&setup=true&lang=ts"

import "./AssetSuccessPage.vue?vue&type=style&index=0&id=05bd04a8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05bd04a8"]])

export default __exports__